const {
    DateTime
} = require('luxon');

class TimeRange {
    constructor(year) {
        this.year = year
    }
    dateTimeHashMap = {
        January: {
            startDate: '1/1/16 0:00',
            endDate: '1/31/16 23:59'
        },
        February: {
            startDate: '2/1/16 0:00',
            endDate: '2/29/16 23:59'
        },
        March: {
            startDate: '3/1/16 0:00',
            endDate: '3/31/16 23:59'
        },
        April: {
            startDate: '4/1/16 0:00',
            endDate: '4/30/16 23:59'
        },
        May: {
            startDate: '5/1/16 0:00',
            endDate: '5/31/16 23:59'
        },
        June: {
            startDate: '6/1/16 0:00',
            endDate: '6/30/16 23:59'
        },
        July: {
            startDate: '7/1/16 0:00',
            endDate: '7/31/16 23:59'
        },
        August: {
            startDate: '8/1/16 0:00',
            endDate: '8/31/16 23:59'
        },
        September: {
            startDate: '9/1/16 0:00',
            endDate: '9/30/16 23:59'
        },
        October: {
            startDate: '10/1/16 0:00',
            endDate: '10/31/16 23:59'
        },
        November: {
            startDate: '11/1/16 0:00',
            endDate: '11/30/16 23:59'
        },
        December: {
            startDate: '12/1/16 0:00',
            endDate: '12/31/16 23:59'
        },
        "Q1": {
            startDate: '1/1/16 0:00',
            endDate: '3/31/16 23:59'
        },
        "Q2": {
            startDate: '4/1/16 0:00',
            endDate: '6/30/16 23:59'
        },
        "Q3": {
            startDate: '7/1/16 0:00',
            endDate: '9/30/16 23:59'
        },
        "Q4": {
            startDate: '10/1/16 0:00',
            endDate: '12/31/16 23:59'
        },
        "H1": {
            startDate: '1/1/16 0:00',
            endDate: '6/30/16 23:59'
        },
        "H2": {
            startDate: '7/1/16 0:00',
            endDate: '12/31/16 23:59'
        },
        "CY": {
            startDate: '1/1/16 0:00',
            endDate: '12/31/16 23:59'
        }
    }
    getTimeRange = (timeSelectorValue) => {
        var timeStamp = {},
            startDate = Object.keys(this.dateTimeHashMap).includes(timeSelectorValue) ? this.dateTimeHashMap[timeSelectorValue]['startDate'] : '1/1/16 0:00',
            endDate = Object.keys(this.dateTimeHashMap).includes(timeSelectorValue) ? this.dateTimeHashMap[timeSelectorValue]['endDate'] : '12/31/23:59';
        timeStamp['startTime'] = Number(DateTime.fromFormat(startDate, 'M/d/yy H:mm'));
        timeStamp['endTime'] = Number(DateTime.fromFormat(endDate, 'M/d/yy H:mm'));
        return timeStamp;
    }
}

export default TimeRange;


// WEBPACK FOOTER //
// ./src/util/getTimeRange.js